import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import $ from 'jquery';
import { withT } from '../../../i18n';

class RainVillage extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <a href=""><AutoVideo controls src={assetUrl('home/RainVillage.mp4')} poster={assetUrl('home/RainVillage.jpg')}></AutoVideo></a>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">Rain Village</h2>

                                <h2 className="artist_name"><span>{t('work.by')} </span> SeerLight </h2>
                                <div className="desc">
                                    <p>Ninjas eating ramen in the rain.</p>
                                </div>

                                <a href="https://opensea.io/assets/0x3b3ee1931dc30c1957379fac9aba94d1c48a5405/5907" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(RainVillage);
